// Resized WebP copy of a project image via the imgproxy CDN (cdn-img.thrivestate.dev). Sources
// can be any public image URL; legacy cdn.thrivestate.dev URLs are read straight from the dev
// bucket. Callers keep the original URL as an <img> @error fallback.
const IMGPROXY_BASE = 'https://cdn-img.thrivestate.dev/VC_qlYD_wXOjkaoVM_h2NTa_Ccg_GdLh0swrfoVlRWs';

const encodeSource = (path: string): string => {
  try {
    return btoa(unescape(encodeURIComponent(path)));
  } catch {
    return btoa(path);
  }
};

export const resizedImageUrl = (url: string, dims: readonly [number, number]): string => {
  const source = url.replace('https://cdn.thrivestate.dev/', 'gs://thrivestate-dev-bucket-europe-west1/');
  return `${IMGPROXY_BASE}/rs:fit:${dims[0]}:${dims[1]}:0/g:no/${encodeSource(source)}.webp`;
};

// Floor-plan thumbnails on the Layouts / Availability tabs.
export const FLOOR_PLAN_THUMB_DIMS = [480, 360] as const;
